module.exports = __webpack_public_path__ + "img/2大東藝文中心.92a50c86.jpg";